import { createStore, compose } from 'redux';
import reducers from '../redux/index';

const store = createStore(reducers,
    compose(
        window.devToolsExtension
          ? window.devToolsExtension()
          : function (f) {
              return f;
            }
      ))

export default store;